<div class="flex justify-end">
  <div class="relative w-60">
    <!-- Input field (search + trigger dropdown) -->
    <input
      type="text"
      [(ngModel)]="searchInsider"
      (keydown.enter)="onSearchEnter()"
      placeholder="Type and press Enter to search..."
      class="border border-gray-300 rounded px-3 py-1 text-sm w-full"
      (focus)="showDropdown = filteredInsiders.length > 0"
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'searchInsider')"
    />

    <!-- Dropdown panel -->
    <div
      *ngIf="showDropdown && filteredInsiders.length > 0"
      class="absolute z-50 mt-1 w-full border border-gray-300 bg-white shadow-md max-h-60 overflow-auto rounded"
    >
      <div
        *ngFor="let insider of filteredInsiders"
        class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
        (click)="onInsiderSelect(insider)"
      >
        {{ insider.asReportedInsiderName }}
      </div>
    </div>
  </div>
</div>
<div
  class="grid gap-6 my-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="companyName"
      [(ngModel)]="formData.insiderName"
      [ngClass]="{
        'border-red-500': validationErrors.insiderName
      }"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'insiderName')"
      (input)="validationErrors.insiderName = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-md text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Insider name
    </label>
    <small
      *ngIf="validationErrors.insiderName"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.insiderName }}
    </small>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cik"
      [(ngModel)]="formData.insiderCik"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'insiderCik')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Cik
    </label>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="p2iq"
      [(ngModel)]="formData.p2iq"
      readonly
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'p2iq')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      P2iq
    </label>
  </div>
   <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="insiderComment"
      [(ngModel)]="formData.insiderComment"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'insiderComment')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Insider Comment
    </label>
  </div>
</div>

<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onUpdate()"
  >
    Update
  </button>
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
